import vxlColors from 'shared/styles/color/core';

const background = {
  surface: vxlColors.core.neutrals.grey[100],
  primary: vxlColors.core.neutrals.white,
  secondary: vxlColors.core.neutrals.grey[200],
  tertiary: vxlColors.core.neutrals.grey[100],
  overlay: `${vxlColors.core.neutrals.black}5c`,
};

export default background;
